<div class="cmdb-search-gadget-container">
	<cpi-search-input #searchInput [labels]="labels" [tags]="searchTags" (getSearch)="searchCis($event.tag, $event.text)">
	</cpi-search-input>

	@if (showTable && !isLoadingCiArr) {
		<div class="msp-table-section">
			<div class="msp-table-container" [ngClass]="{ loading: isLoadingCiArr }">
				<div class="table-line header" [ngClass]="{ extended: selectedTag !== undefined }">
					<div class="header-title">ID</div>
					<div class="header-title">{{ labels['lbl_geral_identificacao'] }}</div>
					<div class="header-title">{{ labels['lbl_geral_tipo'] }}</div>
					@if (selectedTag !== undefined) {
						<div>
							<span>{{
								labels[selectedTag.placeholder_label]
									? labels[selectedTag.placeholder_label]
									: selectedTag.placeholder_label
							}}</span>
						</div>
					}
				</div>
				@for (ci of ciArr; track $index) {
					<div class="table-line" [ngClass]="{ extended: selectedTag !== undefined }" (click)="emitCi(ci)">
						<div>
							<span>{{ ci.id }}</span>
						</div>
						<div>
							<span>{{ ci.identification }}</span>
						</div>
						<div>
							<span>{{ labels[ci.type] ? labels[ci.type] : ci.type }}</span>
						</div>
						@if (selectedTag !== undefined) {
							<div>
								<span>{{ ci[selectedTag.tag] }}</span>
							</div>
						}
					</div>
				}
			</div>
		</div>
	}
	@if (isLoadingCiArr) {
		<cpi-square-post-loading-effect [animationSpeed]="'750ms'"></cpi-square-post-loading-effect>
	}
	<!-- <app-msp-cmdb-table-like></app-msp-cmdb-table-like> -->
</div>
